import { array, record, string, union } from 'io-ts/Decoder';

export const Attributes = record(union(string, array(string)));
